import { isLink, isParagraph } from "datocms-structured-text-utils"
import * as React from "react"
import { renderNodeRule } from "react-datocms"

import Paragraph from "../../design-system/paragraph"
import Subtitle from "../../design-system/subtitle"
import UniversalLink from "../../design-system/universal-link"
import * as analytics from "../../utils/analytics"
import { isInternalUrl } from "../../utils/anchor-links"
import { Locale } from "../../utils/locales/constants"
import {
  getCompanyStatsString,
  isCompanyStatsInlineLink,
  StructuredTextRecord,
} from "./company-stats"

export const noParagraphs = renderNodeRule(isParagraph, ({ children, key }) => (
  <React.Fragment key={key}>{children}</React.Fragment>
))

export const datoLink = renderNodeRule(
  isLink,
  ({ children, key, node: { meta, url } }) => {
    const analyticsProperties = meta?.reduce(
      (accumulator, entry) => ({
        ...accumulator,
        [entry.id]: entry.value,
      }),
      {
        target: undefined,
        eventName: undefined,
      },
    )
    if (isInternalUrl(url)) {
      return (
        <UniversalLink
          key={key}
          to={url}
          onClick={() => {
            if (analyticsProperties) {
              analytics.itemClicked(analyticsProperties)
            }
          }}
        >
          {children}
        </UniversalLink>
      )
    }
    return (
      <UniversalLink
        to={url}
        trackingProperties={analyticsProperties}
        target={analyticsProperties?.target}
        onClick={() => {
          if (analyticsProperties?.eventName) {
            analytics.track(analyticsProperties?.eventName)
          }
        }}
      >
        {children}
      </UniversalLink>
    )
  },
)

export const datoParagraph = (variant?: "1" | "2" | "3") =>
  renderNodeRule(isParagraph, ({ children, key }) => (
    <Paragraph variant={variant || "2"} key={key}>
      {children}
    </Paragraph>
  ))

export const datoSubtitle = renderNodeRule(isParagraph, ({ children, key }) => (
  <Subtitle as="p" key={key}>
    {children}
  </Subtitle>
))

export const datoInlineLink = (
  { record }: StructuredTextRecord,
  locale: Locale,
) => {
  if (isCompanyStatsInlineLink(record)) {
    const { link } = record
    const formattedValue = getCompanyStatsString(record, locale)
    if (link) {
      return <UniversalLink to={link}>{formattedValue}</UniversalLink>
    }
    return <span>{formattedValue}</span>
  }
  return null
}
